<script setup>
import { router, Head, Link, useForm, usePage } from '@inertiajs/vue3';
import { reactive } from 'vue';
import JetButton from '@/Jetstream/Button.vue';
import JetAuditorHeader from '@/Jetstream/AuditorHeader.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';

// Get locale as set in cookie
const { locale, fallbackLocale} = useI18n({ useScope: 'global' });

// Check if in auditor mode
let auditor = false;
let toolkitID = '';
let auditorSession = [];
let auditorName = '';
if (router.page.props.auditor) {
    auditor = router.page.props.auditor;
    toolkitID = router.page.props.toolkitID;
    auditorSession = router.page.props.auditorSession;
    auditorName = auditorSession.auditor_name;
}

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;
const urlNamePrefix = organisation ? "gi." : "";
const formData = reactive([]);

</script>

<template>

    <AppTheming />

    <Head title="Auditor Feedback Questions" />

    <JetAuditorHeader v-if="organisation != undefined" :programme="programme" :organisation="organisation" />
    <JetAuditorHeader v-else :programme="programme" />

    <div id="content-wrapper" class="bg-gray-200 auditor-content-wrapper">
        <div id="main-content" class="container w-full pt-5 pb-5 mx-auto">

            <div class="sm:pl-10 sm:pr-10">
                <div class="mt-0 text-gray-500">
                    <div class="mt-10 mb-10 form-item-container">

                        <h1 class="dashboard-title">
                            {{ $t('auditor.audit_complete.audit_complete_heading') }}
                        </h1>
                        <p class="font-bold">{{ $t('auditor.audit_complete.audit_complete_thankyou') }}</p>
                        <p class="font-bold">{{ $t('auditor.audit_complete.audit_complete_notice') }}</p>

                        <div v-if="organisation">
                                <div>
                                    <a
                                        :href="route(urlNamePrefix+'auditor.teamSelect', { 'subdomain': 'auditor'})"
                                        class="inline-flex items-center px-4 py-2 mr-3 text-xs font-semibold tracking-widest text-white uppercase transition bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25"
                                        >
                                        {{ $t('auditor.audit_complete.audit_another_team') }}
                                    </a>

                                    <a
                                        :href="route(urlNamePrefix+'auditor.login', { 'subdomain': 'auditor'})"
                                        class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-white uppercase transition bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25"
                                        >
                                        {{ $t('auditor.audit_complete.sign_out') }}
                                    </a>
                                </div>
                        </div>

                        <div v-else>

                            <a
                                :href="route(urlNamePrefix+'auditor.login', { 'subdomain': 'auditor'})"
                                class="inline-flex items-center px-4 py-2 mr-3 text-xs font-semibold tracking-widest text-white uppercase transition bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25"
                                >
                                {{ $t('auditor.audit_complete.enter_another_code') }}
                            </a>

                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
